if (!customElements.get('leslis-announcements')) {
  customElements.define('leslis-announcements', class extends HTMLElement {
    connectedCallback() {
      this.messages = [...this.querySelectorAll('[data-message]')];
      if (this.messages.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.rotate !== 'true' || this.motion.matches;
      this.pauseButton = this.querySelector('[data-pause]');
      this.pauseButton.hidden = false;
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, options);
      this.addEventListener('focusin', event => { if (event.target !== this.pauseButton) { this.paused = true; this.update(); } }, options);
      this.addEventListener('pointerenter', () => this.stop(), options);
      this.addEventListener('pointerleave', () => this.update(), options);
      document.addEventListener('visibilitychange', () => this.update(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.messages.findIndex(message => message.contains(event.target));
        if (index >= 0) { this.paused = true; this.show(index); this.update(); }
      }, options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.update(); }, options);
      this.update();
    }
    show(index) {
      this.index = (index + this.messages.length) % this.messages.length;
      this.messages.forEach((message, i) => { message.hidden = i !== this.index; });
    }
    stop() { clearInterval(this.timer); }
    update() {
      this.stop();
      this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
      if (!this.paused && !document.hidden && !this.matches(':hover')) {
        this.timer = setInterval(() => this.show(this.index + 1), Math.max(5000, Number(this.dataset.interval) || 7000));
      }
    }
    disconnectedCallback() { this.stop(); this.abort?.abort(); }
  });
}
